import { render } from "./default-layout.vue?vue&type=template&id=8684113c"
import script from "./default-layout.vue?vue&type=script&lang=js"
export * from "./default-layout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__